import React, { useEffect, useRef, useState } from 'react'
import {
  Box,
  Button,
  Slide,
  Paper,
  IconButton,
  Card,
  Badge,
  CircularProgress,
  Stack,
  ClickAwayListener,
  Grow,
  Tooltip,
  Typography,
} from '@material-ui/core'
import { styled } from '@material-ui/styles'
import CloseIcon from '@material-ui/icons/Close'
import ChatMain from './ChatMain'
import ChatSidebarSignWise from './ChatRightScreen/ChatSidebarSignWise'
import ChatScreenWindow from './ChatLeftScreen/ChatScreenWindow'
import { useDispatch } from 'react-redux'
import { getContacts, getConversations } from 'src/redux/slices/chat'
import IMG from '../../../Gif/apple-touch-icon.png'
import { MBadge } from 'src/components/@material-extend'
import axios from 'axios'
import { DOMAIN, REST_API_END_POINT, STATUS_OPTIONS } from 'src/constants/DefaultValues'
import { WA } from './whatsappTheme'
import {
  getChatNotificationsEnabled,
  setChatNotificationsEnabled,
  downloadChatTranscript,
} from './chatWidgetPrefs'
import ChatWidgetSettings from './ChatWidgetSettings'
import ChatIncomingToast, { notifyIncomingChatMessage } from './ChatIncomingToast'
import { initChatNotificationSound, unlockChatNotificationSound } from './chatNotificationSound'
import { createChatSocket } from 'src/Helpers/createSocket'
// import owlNotification from '../../../assets/owl-notif.png'
// Styled Button for Floating Chat
const FloatingButton = styled(Button)(({ theme }) => ({
  position: 'fixed',
  bottom: 24,
  right: 24,
  zIndex: 1250,
  width: 56,
  height: 56,
  minWidth: 56,
  padding: 0,
  borderRadius: '50%',
  backgroundColor: WA.fab,
  color: '#fff',
  boxShadow: '0 4px 16px rgba(0, 0, 0, 0.25)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  '&:hover': {
    backgroundColor: '#015A8E',
  },
  '& *': {
    pointerEvents: 'none',
  },
  [theme.breakpoints.down('sm')]: {
    right: 16,
    bottom: 16,
  },
}))

const PopupChat = styled(Paper)(({ theme }) => ({
  position: 'fixed',
  bottom: 92,
  right: 24,
  zIndex: 1240,
  width: 880,
  height: 620,
  maxWidth: 'calc(100vw - 32px)',
  maxHeight: 'calc(100vh - 120px)',
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  borderRadius: 20,
  border: `1px solid ${WA.border}`,
  boxShadow: WA.shadow,
  [theme.breakpoints.down('sm')]: {
    right: 8,
    bottom: 84,
    width: 'calc(100vw - 16px)',
    height: 'calc(100vh - 110px)',
    borderRadius: 16,
  },
  '&.is-maximized': {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: '100%',
    height: '100%',
    maxWidth: 'none',
    maxHeight: 'none',
    borderRadius: 0,
    zIndex: 1400,
  },
}))

export default function FloatingChat() {
  const [open, setOpen] = useState(false)
  const [openCompose, setCompose] = useState(true)
  const dispatch = useDispatch()
  const user = localStorage.getItem('user')
  const userData = JSON.parse(user)
  const isAdmin = true || userData.user_type === 1
  const [teamMembers, setTeamMembers] = useState([])
  const [chatCount, setChatCount] = useState(0)
  console.log('chatCount+++++++++++', chatCount)
  const [selectedContact, setSelectedContact] = useState(null)
  const [renderChat, setRenderChat] = useState(false)
  const [loading, setLoading] = useState(true)
  const [status, setStatus] = useState(null)
  const [refreshStatus, setRefreshStatus] = useState(false)
  const [showHistory, setShowHistory] = useState(true)
  const [chatOpenTime, setChatOpenTime] = useState(null)
  const [historyMessage, setHistoryMessage] = useState([])
  const [selectedChatLogId, setSelectedChatLogId] = useState(null)
  const [newChat, setNewChat] = useState(false)
  const [position, setPosition] = useState(null)
  const isDragging = useRef(false)
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [isDraggingNow, setIsDraggingNow] = useState(false);
  const socketRef = useRef(null);
  const fetchDataRef = useRef(null);
  const openRef = useRef(false);
  const onChatScreenRef = useRef(false);
  const owlNotification = `${process.env.PUBLIC_URL}/favicon/owl-notif.png`;
  const [onChatScreen,setOnChatScreen]=useState(false);
  const [mobileChat,setMobileChat]=useState(true);
  const originalTitle = useRef(document.title);
  const blinkIntervalRef = useRef(null);
  const originalFavicon = useRef(null);
  const [maximized, setMaximized] = useState(false)
  const [notificationsEnabled, setNotificationsEnabled] = useState(() =>
    getChatNotificationsEnabled(),
  )
  const notificationsRef = useRef(notificationsEnabled)
  notificationsRef.current = notificationsEnabled
  const transcriptMessagesRef = useRef([])
  const setFavicon = (iconURL) => {
    let link = document.querySelector("link[rel*='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    link.href = iconURL + '?v=' + new Date().getTime();
  };
  
  const handleIncomingSocketMessage = (msg) => {
    if (msg?.domain !== DOMAIN) return

    let receivedConversationId = String(msg.conversationId)
    let senderConversationId = String(msg.senderId)
    const currentUserId = userData.user_id
    const isOwnMessage = senderConversationId === String(currentUserId)
    const isGroupChat = msg.conversationId?.startsWith('chat_')
    let userID = String(userData.user_id)
    const isChatOpen = openRef.current
    const isOnChatScreen = onChatScreenRef.current

    if (msg.conversationId?.startsWith('user_')) {
      if (!userID.startsWith('user_')) userID = `user_${userID}`
      if (!receivedConversationId.startsWith('user_')) {
        receivedConversationId = `user_${receivedConversationId}`
      }
      if (!senderConversationId.startsWith('user_')) {
        senderConversationId = `user_${senderConversationId}`
      }
      if (receivedConversationId === userID && !isOwnMessage) {
        if (!isChatOpen) {
          setChatCount((prev) => (Number(prev) || 0) + 1)
        }
        setTimeout(() => {
          fetchDataRef.current?.(true)
        }, 700)
        window.dispatchEvent(new CustomEvent('signwise-chat-incoming', { detail: msg }))
        if (msg?.contentType !== 'chat_rating') {
        notifyIncomingChatMessage(msg, {
          myUserId: currentUserId,
          fallbackTitle: 'User',
          whenChatOpen: isChatOpen && isOnChatScreen,
        })
        }
        if (msg?.contentType !== 'chat_rating' && !isChatOpen && !isOnChatScreen && notificationsRef.current) {
          if (!originalFavicon.current) {
            const link = document.querySelector("link[rel~='icon']")
            originalFavicon.current = link?.href
          }
          let showBlue = true
          blinkIntervalRef.current = setInterval(() => {
            setFavicon(showBlue ? owlNotification : originalFavicon.current)
            showBlue = !showBlue
          }, 1000)
        }
      }
      return
    }

    if (isGroupChat) {
      const participantIds = Array.isArray(msg.participants)
        ? msg.participants.map((p) => Number(p.user_id ?? p.id)).filter(Boolean)
        : []
      const isRecipientInGroup = participantIds.includes(Number(currentUserId))
      if (isRecipientInGroup && !isOwnMessage) {
        if (!isChatOpen) {
          setChatCount((prev) => (Number(prev) || 0) + 1)
        }
        setTimeout(() => {
          fetchDataRef.current?.(true)
        }, 700)
        window.dispatchEvent(new CustomEvent('signwise-chat-incoming', { detail: msg }))
        if (msg?.contentType !== 'chat_rating') {
          notifyIncomingChatMessage(msg, {
            myUserId: currentUserId,
            fallbackTitle: 'User',
            whenChatOpen: isChatOpen && isOnChatScreen,
          })
        }
        if (
          msg?.contentType !== 'chat_rating' &&
          !isChatOpen &&
          !isOnChatScreen &&
          notificationsRef.current
        ) {
          if (!originalFavicon.current) {
            const link = document.querySelector("link[rel~='icon']")
            originalFavicon.current = link?.href
          }
          let showBlue = true
          blinkIntervalRef.current = setInterval(() => {
            setFavicon(showBlue ? owlNotification : originalFavicon.current)
            showBlue = !showBlue
          }, 1000)
        }
      }
    }
  }

  useEffect(() => {
    initChatNotificationSound()
    const socket = createChatSocket()
    socketRef.current = socket
    socket.on('message', handleIncomingSocketMessage)

    return () => {
      socket.off('message', handleIncomingSocketMessage)
      if (blinkIntervalRef.current) {
        clearInterval(blinkIntervalRef.current)
        blinkIntervalRef.current = null
      }
      if (originalFavicon.current) {
        setFavicon(originalFavicon.current)
      }
    }
  }, [userData?.user_id])

useEffect(() => {
  const handleFocus = () => {
    if (blinkIntervalRef.current) {
      clearInterval(blinkIntervalRef.current);
      blinkIntervalRef.current = null;
    }
    if (originalFavicon.current) {
      setFavicon(originalFavicon.current);
    }
    document.title = originalTitle.current;
  };

  window.addEventListener('focus', handleFocus);
  return () => {
    window.removeEventListener('focus', handleFocus);
  };
}, []);

  
console.log('owlNotification resolved path:', owlNotification);


  const isMobile = windowWidth < 768
  const isMd = windowWidth < 900

useEffect(() => {
  const handleResize = () => {
    setWindowWidth(window.innerWidth);
  };

  window.addEventListener('resize', handleResize);
  return () => window.removeEventListener('resize', handleResize);
}, []);


  const clampPosition = (x, y) => ({
    x: Math.min(Math.max(0, x), window.innerWidth - 60),
    y: Math.min(Math.max(0, y), window.innerHeight - 60),
  })

  const fetchSavedPosition = async () => {
    try {
      const response = await axios.post(
        `${REST_API_END_POINT}get-chat-position`,
        {
          userId: userData.user_id,
        },
      )

      if (response.data.status === 1) {
        const { position_x, position_y } = response?.data
        if (
          position_x !== null &&
          position_y !== null &&
          position_x !== undefined &&
          position_y !== undefined
        ) {
          const clamped = clampPosition(position_x, position_y)
          setPosition(clamped)
        } else {
          const fallback = {
            x: window.innerWidth - 100,
            y: window.innerHeight - 150,
          }
          setPosition(fallback)
        }
      }
    } catch (err) {
      console.error('Failed to fetch saved position:', err)
      const fallback = {
        x: window.innerWidth - 100,
        y: window.innerHeight - 150,
      }
      setPosition(fallback)
    }
  }

  // useEffect(() => {
  //   // fetchSavedPosition()
  //   const clamped = clampPosition(314, 15)
  //   setPosition(clamped)
  // }, [isMd])

  const handleDrag = (e, data) => {
    isDragging.current = true
    setIsDraggingNow(true)
    setPosition({ x: data.x, y: data.y })
  }

  const handleDragStop = async (e, data) => {
    setTimeout(() => {
      isDragging.current = false
      setIsDraggingNow(false)
    }, 200)

    const clamped = clampPosition(data.x, data.y)
    setPosition(clamped)
    setPosition(clamped)

    try {
      await axios.post(`${REST_API_END_POINT}update-chat-position`, {
        userId: userData.user_id,
        chat_position_x: data.x,
        chat_position_y: data.y,
      })
      console.log(' Chat position saved:', clamped)
    } catch (err) {
      console.error(' Failed to save position:', err)
    }
  }

  const fetchStatus = async () => {
    try {
      const response = await axios.post(
        `${REST_API_END_POINT}chat/get-chat-status-by-userid`,
        { userId: userData.user_id },
      )
      if (response.data.status === 1) {
        const fetchedStatus = response.data.result.chat_status
        const filteredStatus = STATUS_OPTIONS?.find(
          (item) => item.id == fetchedStatus,
        )
        console.log('newStatus---filteredStatus-1--', filteredStatus)
        setStatus(filteredStatus)
        console.log('Status set successfully')
      } else {
        console.log('Status not found')
      }
    } catch (error) {
      console.log('Error finding status : ', error)
    }
  }

  useEffect(() => {
    fetchStatus()
  }, [refreshStatus, open])
  const fetchData = async (updateSelctedContact = false) => {
    if (isAdmin && userData) {
      try {
        const response = await axios.post(
          `${REST_API_END_POINT}chat/get-chat-list`,
          {
            usersId: userData.user_id,
            usersType: userData.user_type,
            // page:page+1,rowsPerPage,search:filterName,
          },
        )
        if (response.data.data) {
          const newData = response.data.data
          const TotalUnread = response.data.totalUnreadCount
          setTeamMembers(newData)
          setChatCount(TotalUnread)
          if (updateSelctedContact && selectedContact?.new_conversation_id) {
            const filteredData = newData.find(
              (member) =>
                member?.new_conversation_id ===
                  selectedContact?.new_conversation_id ||
                (selectedContact?.conversation_id &&
                  Number(member?.conversation_id) ===
                    Number(selectedContact.conversation_id)),
            )
            if (filteredData) {
              setSelectedContact((prev) => ({
                ...filteredData,
                openedAt: prev?.openedAt,
              }))
            }
          }
        } else {
          setTeamMembers([])
          setChatCount(0)
        }
      } catch (error) {
        console.log('Error fetching data: ', error)
      } finally {
        setLoading(false)
      }
    }
  }

  fetchDataRef.current = fetchData

  useEffect(() => {
    openRef.current = open
  }, [open])

  useEffect(() => {
    onChatScreenRef.current = onChatScreen
  }, [onChatScreen])

  useEffect(() => {
    fetchData()
  }, [open])

  useEffect(() => {
    fetchData(true)
  }, [renderChat])

  const handleRefresh = () => {
    fetchData(true)
  }

  const refreshChat = () => {
    setRenderChat(!renderChat)
  }

  useEffect(() => {
    dispatch(getConversations())
    dispatch(getContacts())
  }, [dispatch])

  const handleToggleNotifications = (enabled) => {
    setChatNotificationsEnabled(enabled)
    setNotificationsEnabled(enabled)
  }

  const handleDownloadTranscript = () => {
    const contact = selectedContact
    downloadChatTranscript({
      messages: transcriptMessagesRef.current || [],
      title:
        contact?.group_name || contact?.full_name
          ? `${contact.group_name || contact.full_name} transcript`
          : 'Help Desk chat transcript',
      treatYouAsAgent: true,
    })
  }

  const togglePopup = () => {
    unlockChatNotificationSound()
    setOpen(!open)
    setOnChatScreen(!onChatScreen)
    setCompose(true)
    setShowHistory(false)
    setSelectedContact(null)
    // console.log('showHistoryshowHistory',!showHistory,selectedContact)
  }
  const openChat = () => {
    setCompose(false)
  }

  return (
    <>
      <ChatIncomingToast
        onOpen={() => {
          unlockChatNotificationSound()
          setOpen(true)
        }}
      />
      {/* <FloatingButton onClick={togglePopup}>
        <Badge badgeContent={3} color="error" overlap="circular">
          <Box
            component="img"
            src={IMG}
            alt="LOGO"
            sx={{ width: 45, height: 45, objectFit: 'cover', mt: 0.5 }}
          />
        </Badge>
      </FloatingButton> */}

      {/* {position && !isMobile && (
        <Draggable
          bounds="body"
          position={position}
          onDrag={handleDrag}
          onStop={handleDragStop}
        >
          <div
            className="drag-wrapper"
            style={{ position: 'fixed', zIndex: 9999,cursor: isDraggingNow ? 'grabbing' : 'grab', }}
          >
            <FloatingButton
              onClick={() => {
                if (!isDragging.current) togglePopup()
              }}
            >
              <Badge badgeContent={chatCount} color="error" overlap="circular">
                <Box
                  component="img"
                  src={IMG}
                  alt="LOGO"
                  sx={{ width: 45, height: 45, objectFit: 'cover', mt: 0.5 }}
                />
              </Badge>
            </FloatingButton>
          </div>
        </Draggable>
      )} */}
      
      {!open && (
        <Tooltip title="Help Desk inbox" placement="left" arrow>
          <FloatingButton
            data-testid="floating-chat-button"
            onClick={() => {
              if (!isDragging.current) togglePopup()
            }}
          >
            <Badge badgeContent={chatCount} color="error" overlap="circular">
              <Box
                component="img"
                src={IMG}
                alt="Signwise"
                sx={{ width: 45, height: 45, objectFit: 'cover', borderRadius: '50%', mt: 0.5 }}
              />
            </Badge>
          </FloatingButton>
        </Tooltip>
      )}

      {/* {isMobile && (
        <div style={{ position: 'fixed', bottom: 80, right: 80, zIndex: 9999,cursor: isDragging.current ? 'grabbing' : 'grab', }}>
          <FloatingButton onClick={togglePopup}>
            <Badge badgeContent={chatCount} color="error" overlap="circular">
              <Box
                component="img"
                src={IMG}
                alt="LOGO"
                sx={{ width: 45, height: 45, objectFit: 'cover', mt: 0.5 }}
              />
            </Badge>
          </FloatingButton>
        </div>
      )} */}

      <Slide direction="up" in={open} mountOnEnter unmountOnExit timeout={250}>
        <PopupChat className={maximized ? 'is-maximized' : undefined}>
          <Box
            sx={{
              pl: 2.5,
              pr: 1,
              py: 1.5,
              display: 'flex',
              alignItems: 'center',
              bgcolor: WA.header,
              color: '#fff',
              flexShrink: 0,
            }}
          >
            <Box sx={{ flexGrow: 1, minWidth: 0 }}>
              <Typography variant="subtitle1" sx={{ fontWeight: 800, letterSpacing: '-0.2px', lineHeight: 1.2 }}>
                Help Desk Inbox
              </Typography>
              <Typography variant="caption" sx={{ opacity: 0.85, display: 'block', mt: 0.25 }}>
                Conversations from the live chat widget
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0, flexShrink: 0 }}>
              <ChatWidgetSettings
                tone="light"
                maximized={maximized}
                onToggleMaximize={() => setMaximized((prev) => !prev)}
                notificationsEnabled={notificationsEnabled}
                onToggleNotifications={handleToggleNotifications}
                onDownloadTranscript={handleDownloadTranscript}
                showReviews
              />
              <IconButton
                size="small"
                onClick={togglePopup}
                aria-label="Close inbox"
                sx={{
                  color: '#fff',
                  width: 36,
                  height: 36,
                  p: 0,
                  flexShrink: 0,
                  bgcolor: 'transparent',
                  '&:hover': { bgcolor: 'rgba(255,255,255,0.2)' },
                }}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            </Box>
          </Box>
          <Card
            sx={{
              flexGrow: 1,
              minHeight: 0,
              display: 'flex',
              boxShadow: 'none',
              borderRadius: 0,
              overflow: 'hidden',
            }}
          >
            <ChatSidebarSignWise
              compact
              openCompose={openCompose}
              setCompose={setCompose}
              setOpen={setOpen}
              teamMembers={teamMembers}
              setSelectedContact={setSelectedContact}
              selectedContact={selectedContact}
              refreshChat={refreshChat}
              setRenderChat={setRenderChat}
              renderChat={renderChat}
              status={status}
              setStatus={setStatus}
              refresh={refreshStatus}
              setRefresh={setRefreshStatus}
              setShowHistory={setShowHistory}
              showHistory={showHistory}
              chatOpenTime={chatOpenTime}
              setChatOpenTime={setChatOpenTime}
              setHistoryMessage={setHistoryMessage}
              historyMessage={historyMessage}
              selectedChatLogId={selectedChatLogId}
              setSelectedChatLogId={setSelectedChatLogId}
              setNewChat={setNewChat}
              newChat={newChat}
              handleRefresh={handleRefresh}
            />
            <ChatScreenWindow
              compact
              setOnChatScreen={setOnChatScreen}
              openCompose={openCompose}
              setCompose={setCompose}
              teamMembers={teamMembers}
              contact={selectedContact}
              setSelectedContact={setSelectedContact}
              refreshChat={refreshChat}
              setRenderChat={setRenderChat}
              renderChat={renderChat}
              handleRefresh={handleRefresh}
              setShowHistory={setShowHistory}
              showHistory={showHistory}
              chatOpenTime={chatOpenTime}
              setChatOpenTime={setChatOpenTime}
              setHistoryMessage={setHistoryMessage}
              historyMessage={historyMessage}
              selectedChatLogId={selectedChatLogId}
              setSelectedChatLogId={setSelectedChatLogId}
              setNewChat={setNewChat}
              newChat={newChat}
              maximized={maximized}
              onToggleMaximize={() => setMaximized((prev) => !prev)}
              notificationsEnabled={notificationsEnabled}
              onToggleNotifications={handleToggleNotifications}
              onTranscriptMessages={(msgs) => {
                transcriptMessagesRef.current = msgs || []
              }}
            />
          </Card>
        </PopupChat>
      {/* </Grow> */}
      </Slide>
    </>
  )
}
